export default class SigWebTablet {
  constructor(ctx, signatureCallback = null, threshold = 100) {
    this.ctx = ctx;
    this.cb = signatureCallback;
    this.signatureThreshold = threshold;
    this.Count = false;
    this.NumPointsLastTime = 0;
    this.SigWebFontThreshold = 155;
    this.makeUri();
  }

  // eslint-disable-next-line class-methods-use-this
  getBlobURL(obj) {
    // eslint-disable-next-line no-nested-ternary
    return (window.URL && URL.createObjectURL.bind(URL))
      ? URL.createObjectURL(obj)
      : (window.webkitURL && window.webkitURL.createObjectURL.bind(window.webkitURL))
        ? window.webkitURL.createObjectURL(obj)
        : window.createObjectURL(obj);
  }

  // eslint-disable-next-line class-methods-use-this
  revokeBlobURL(obj) {
    // eslint-disable-next-line no-nested-ternary
    return (window.URL && URL.revokeObjectURL.bind(URL))
      ? URL.revokeObjectURL(obj)
      : (window.webkitURL && window.webkitURL.revokeObjectURL.bind(window.webkitURL))
        ? window.webkitURL.revokeObjectURL(obj)
        : window.revokeObjectURL(obj);
  }

  makeUri() {
    this.baseUri = `//tablet.sigwebtablet.com:${
      window.location.protocol === 'https:'
        ? '47290'
        : '47289'
    }/SigWeb/`;
  }

  static SigWebCreateXHR() {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('error', () => {
      throw new Error();
    });
    return xhr;
  }

  SigWebSetProperty(prop) {
    return this.SigWebSetPropertySync(prop);
  }

  SigWebSetPropertySync(prop) {
    const xhr = this.constructor.SigWebCreateXHR();
    if (xhr) {
      xhr.open('POST', `${this.baseUri + prop}?_=${new Date().getTime()}`, false);
      xhr.send();
      if (xhr.readyState === 4 && xhr.status === 200) {
        return xhr.responseText;
      }
    }
    return '';
  }

  SigWebSetStreamProperty(prop, strm) {
    const xhr = this.constructor.SigWebCreateXHR();

    if (xhr) {
      xhr.open('POST', `${this.baseUri + prop}?_=${new Date().getTime()}`, true);
      xhr.send(strm);
    }
    return '';
  }

  SigWebSetImageStreamProperty(prop, strm) {
    const xhr = this.constructor.SigWebCreateXHR();

    if (xhr) {
      xhr.open('POST', `${this.baseUri + prop}?_=${new Date().getTime()}`, true);
      xhr.send(strm);
      if (xhr.readyState === 4 && xhr.status === 200) {
        return xhr.responseText;
      }
    }
    return '';
  }

  SigWebSetImageBlobProperty(prop, strm) {
    const xhr = this.constructor.SigWebCreateXHR();

    if (xhr) {
      xhr.open('POST', `${this.baseUri + prop}?_=${new Date().getTime()}`, true);
      xhr.send(strm);
      if (xhr.readyState === 4 && xhr.status === 200) {
        return xhr.responseText;
      }
    }
    return '';
  }

  SigWebGetProperty(prop) {
    const { baseUri, constructor } = this;
    return new Promise((resolve, reject) => {
      const xhr = constructor.SigWebCreateXHR();
      if (xhr) {
        xhr.open('GET', `${baseUri + prop}?_=${new Date().getTime()}`, true);
        xhr.setRequestHeader('Content-Type', 'text/plain');
        xhr.onload = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            resolve(xhr.responseText);
          } else {
            reject(new Error(`Failed to get property ${prop}`));
          }
        };
        xhr.send(null);
      } else {
        reject(new Error('Failed to create request'));
      }
    });
  }

  GetSigImageB64(callback) {
    const app = this;
    const cvs = document.createElement('canvas');
    cvs.width = this.GetImageXSize();
    cvs.height = this.GetImageYSize();

    const xhr = this.constructor.SigWebCreateXHR();
    if (xhr) {
      xhr.open('GET', `${this.baseUri}SigImage/1?_=${new Date().getTime()}`, true);
      xhr.setRequestHeader('Content-Type', 'text/plain');

      xhr.responseType = 'blob';
      xhr.send(null);
      xhr.onload = function GetSigImageB64Connection() {
        const ctx = cvs.getContext('2d');
        const img = new Image();
        img.src = app.getBlobURL(xhr.response);
        img.onload = function GetSigImageB64ImgLoad() {
          ctx.drawImage(img, 0, 0);
          const b64String = cvs.toDataURL('image/png');
          const loc = b64String.search('base64,');
          const returnString = b64String.slice(loc + 7, b64String.length);
          if (callback) {
            callback(returnString);
          }
        };
      };
    }
  }

  SigWebWaitForPenDown(callback) {
    const xhr = this.constructor.SigWebCreateXHR();

    if (xhr) {
      xhr.open('GET', `${this.baseUri}WaitForPenDown?_=${new Date().getTime()}`, true);
      xhr.timeout = 10000;
      xhr.onreadystatechange = function SigWebWaitForPenDownConnection() {
        if (xhr.readyState !== 4) return;
        if (xhr.status === 200) callback();
      };
      xhr.send(null);
    }
  }

  GetSigImage(ctx) {
    const app = this;
    const xhr = this.constructor.SigWebCreateXHR();
    if (xhr) {
      xhr.open('GET', `${this.baseUri}SigImage/1?_=${new Date().getTime()}`, true);
      xhr.setRequestHeader('Content-Type', 'text/plain');

      xhr.responseType = 'blob';
      xhr.send(null);
      xhr.onload = function GetSigImageConnection() {
        let img = new Image();
        img.src = app.getBlobURL(xhr.response);
        img.onload = function GetSigImageImageLoad() {
          ctx.drawImage(img, 0, 0);
          app.revokeBlobURL(this.src);
          img = null;
        };
      };
    }
  }

  SigWebSetDisplayTarget(obj) {
    this.ctx = obj;
  }

  SigWebRefresh() {
    try {
      const app = this;
      const {
        constructor,
        getBlobURL,
        revokeBlobURL,
        ctx,
      } = this;

      this.NumberOfTabletPoints().then((n) => {
        if (n === app.NumPointsLastTime) {
          return;
        }
        app.NumPointsLastTime = n;
        const xhr = constructor.SigWebCreateXHR();
        if (xhr) {
          xhr.open('GET', `${this.baseUri}SigImage/0?_=${new Date().getTime()}`, true);
          xhr.setRequestHeader('Content-Type', 'text/plain');
          xhr.responseType = 'blob';
          xhr.onload = function SigWebRefreshConnection() {
            let img = new Image();
            img.onload = function SigWebRefreshImageLoad() {
              ctx.drawImage(img, 0, 0);
              revokeBlobURL(img.src);
              img = null;
            };
            img.src = getBlobURL(xhr.response);
          };
          xhr.send(null);
        }
      });
    } catch (_) {
      this.tmr = null;
    }
  }

  SigWebEvent() {
    const OldEvStatus = this.EvStatus;

    const xhr = this.constructor.SigWebCreateXHR();
    if (xhr) {
      xhr.open('GET', `${this.baseUri}EventStatus?_=${new Date().getTime()}`, true);

      xhr.onload = function SigWebEventConnection() {
        this.EvStatus = xhr.responseText;
        // eslint-disable-next-line no-bitwise
        if ((OldEvStatus & 0x01) && (this.EvStatus & 0x02)) {
          if (this.onSigPenDown) {
            this.onSigPenDown();
          }
        }
        // eslint-disable-next-line no-bitwise
        if ((OldEvStatus & 0x02) && (this.EvStatus & 0x01)) {
          if (this.onSigPenUp) {
            this.onSigPenUp();
          }
        }
      };
      xhr.send(null);
    }
  }

  setSigWebFontThreshold(v) {
    this.SigWebFontThreshold = v;
  }

  static toHex(NibVal) {
    return [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
    ][NibVal] || null;
  }

  async GetTabletState() {
    const prop = await this.SigWebGetProperty('TabletState');
    return prop;
  }

  SetTabletState(v, tv) {
    const delay = tv || 100;
    if (this.GetTabletState() !== v) {
      if (v === 1) {
        const app = this;
        const can = this.ctx.canvas;
        this.SetDisplayXSize(can.width);
        this.SetDisplayYSize(can.height);
        this.SigWebSetDisplayTarget(this.ctx);
        this.SetRealTabletState(v);
        this.tmr = setInterval(() => app.SigWebRefresh(), delay);
      } else {
        clearInterval(this.tmr);
        this.tmr = null;
      }
    }
    return this.tmr;
  }

  SetRealTabletState(v) {
    this.SigWebSetPropertySync(`TabletState/${v}`);
  }

  SetDisplayXSize(v) {
    this.SigWebSetPropertySync(`DisplayXSize/${v}`);
  }

  SetDisplayYSize(v) {
    this.SigWebSetPropertySync(`DisplayYSize/${v}`);
  }

  SetJustifyMode(v) {
    this.SigWebSetPropertySync(`JustifyMode/${v}`);
  }

  async ClearTablet() {
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    const prop = await this.SigWebGetProperty('ClearSignature');
    return prop;
  }

  async NumberOfTabletPoints() {
    const prop = await this.SigWebGetProperty('TotalPoints');
    if (this.cb) {
      this.cb(Number(prop) >= this.signatureThreshold);
    }
    return prop;
  }

  SetSigCompressionMode(v) {
    this.SigWebSetPropertySync(`CompressionMode/${v}`);
  }

  async GetSigString() {
    const Str = await this.SigWebGetProperty('SigString');
    return Str.slice(1, Str.length - 1);
  }

  SetImagePenWidth(v) {
    this.SigWebSetPropertySync(`ImagePenWidth/${v}`);
  }

  async GetImagePenWidth() {
    const prop = await this.SigWebGetProperty('ImagePenWidth');
    return prop;
  }

  SetImageXSize(v) {
    this.SigWebSetPropertySync(`ImageXSize/${v}`);
  }

  async GetImageXSize() {
    const prop = await this.SigWebGetProperty('ImageXSize');
    return prop;
  }

  async SetImageYSize(v) {
    const prop = await this.SigWebSetPropertySync(`ImageYSize/${v}`);
    return prop;
  }

  async GetImageYSize() {
    const prop = await this.SigWebGetProperty('ImageYSize');
    return prop;
  }
}
